import React, { useState } from "react";
import enquiry from "../assets/images/enquiry.jpg";
import { Form, Input, InputNumber, message, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { convertUTCDate } from "../utils/convertionFunc";
import CommonService from "../Services/CommonService";

function Query() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleQueryform = async (e) => {
    e.preventDefault();
    const values = form.getFieldValue();
    setLoading(true);
    if (!values.name && !values.email) {
      message.error("Please fill in mandatory fields.");
      setLoading(false);
      return;
    }
    const payload = {
      createdBy: values.name,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      email: values.email,
      mobileNumber: values.mobile,
      modifiedBy: values.name,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      name: values.name,
      planType: null,
      queryContent: values.query,
      status: 1,
    };

    try {
      await CommonService.customerQuery(payload);
      toggleModal();
      message.success("Thank you.. We will get back to you shortly.");
      form.resetFields();
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-between items-center bg-lightBlue rounded-lg shadow p-6 m-6 mx-20">
      {/* Content Section */}
      <div className=" mb-6 md:mb-0 md:pr-6">
        <h2 className="text-2xl font-bold mb-4 headingFont text-[#189FAA]">
          Need Assistance?
        </h2>
        <p className="mb-6 text-[#189FAA] headingFont">
          We are here to help you with any queries.
        </p>
        <button
          onClick={toggleModal}
          className="px-6 py-2 headingFont bg-primaryColor text-white rounded focus:outline-none"
        >
          Enquire Now
        </button>
      </div>

      {/* Image Section */}
      <div className="flex-shrink-0">
        <img
          src={enquiry}
          alt="Enquiry"
          className="w-36 h-36 rounded-[50%] shadow"
        />
      </div>
      <Modal
        open={isModalOpen}
        footer={[]}
        onCancel={toggleModal}
        destroyOnClose
        // title={<h1 className='font-semibold text-xl text-primaryColor'>We'd Love to Hear from You!</h1>}
      >
        <div>
          <div className="p-4 bg-[#E6F7F9] text-base md:text-lg headingFont rounded-md mb-5">
            <p>
              Hello! Please fill out the form below, and we’ll get back to you
              shortly.
            </p>
          </div>
          <Form form={form}>
            <div className="w-full grid grid-cols-2 p-5 rounded-md gap-4">
              {/* Name Field */}
              <div className="relative md:w-4/5 w-full headingFont">
                <span className="absolute md:text-lg text-base font-medium bg-white px-1 z-10 top-[-0.75rem] left-3 text-[#175b66]">
                  Name <span className="text-dangerColor">*</span>
                </span>
                <Form.Item name="name" className="w-full">
                  <Input
                    type="text"
                    name="name"
                    className="w-full md:h-12 h-10 border border-[#7FE8EE] p-1 rounded-lg outline-none"
                  />
                </Form.Item>
              </div>

              {/* Email Address Field */}
              <div className="relative md:w-4/5 w-full headingFont">
                <span className="absolute md:text-lg text-base font-medium bg-white z-10 top-[-0.75rem] left-3 text-[#175b66]">
                  Email Address <span className="text-dangerColor">*</span>
                </span>
                <Form.Item name="email" className="w-full">
                  <Input
                    type="email"
                    name="email"
                    className="w-full md:h-12 h-10 border border-[#7FE8EE] p-1 rounded-lg outline-none"
                  />
                </Form.Item>
              </div>

              {/* Mobile Number Field */}
              <div className="relative md:w-4/5 w-full">
                <span className="absolute md:text-lg text-base font-medium bg-white px-1 z-10 top-[-0.75rem] left-3 text-[#175b66]">
                  Mobile Number
                </span>
                <Form.Item name="mobile" className="w-full">
                  <InputNumber
                    controls={false}
                    type="number"
                    min={0}
                    className="w-full md:h-12 h-10 border border-[#7FE8EE] p-1 rounded-lg outline-none"
                  />
                </Form.Item>
              </div>

              <div className="relative md:w-4/5 w-full">
                <span className="absolute md:text-lg text-base font-medium bg-white z-10 top-[-0.75rem] left-3 text-[#175b66]">
                  Query
                </span>
                <Form.Item name="query" className="mb-0">
                  <TextArea
                    autoSize={{ minRows: 3, maxRows: 3 }}
                    id="unquie-scroll"
                    maxLength={200}
                    name="aboutme"
                    className="md:w-4/5 w-full md:h-12 h-10 overflow-y-auto outline-none border-[#7FE8EE] border p-2 rounded-lg"
                  />
                </Form.Item>
                <p className="text-textGray opacity-50 text-sm">
                  Max 200 characters
                </p>
              </div>
            </div>
          </Form>
          <div className="flex justify-end items-center p-2 gap-3">
            <button
              onClick={toggleModal}
              className="md:min-w-28 w-[6rem] md:w-1/6 md:p-3 p-1 bg-white rounded-lg border text-primaryColor border-primaryColor font-semibold custom-button-shadow"
            >
              Cancel
            </button>
            <button
              onClick={handleQueryform}
              disabled={loading}
              className="md:min-w-28 w-[6rem] md:w-1/6 md:p-3 p-1 bg-primaryColor text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Query;
